import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dot",
  "use": "icon-dot-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dot\"><path fill-rule=\"evenodd\" d=\"M2 0a2 2 0 1 0 0 4 2 2 0 1 0 0-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol